<template>
  <transition-group name="fade" tag="div">
    <div v-for="set in displayed" :key="set.setDiscountId" class="set-discount" :class="{ 'set-discount-grey': greyBackground }">
      <img :src="partyPopper" />
      <p>
        Hey! Your cart includes the
        <span class="bold">{{ set.code }}<template v-if="set.quantity > 1"> x {{ set.quantity }}</template>
        </span>, so you save {{ set.discountAmountWithCurrency }}. Nice.
      </p>
    </div>
  </transition-group>
</template>

<script>
import partyPopper from '@/assets/party-popper.png';
import LocalStorage, {
  LocalStorageKeys,
} from '@/components/commons/LocalStorage.js';
import { keyBy, pickBy, isEqual } from 'lodash-es';

export default {
  name: 'SetDiscounts',

  components: {},

  props: {
    sets: {
      type: Array,
      default: null
    },
    greyBackground: {
      type: Boolean
    }
  },

  data() {
    return {
      partyPopper,
      previous: this.getSetsFromLocalStorage()
    };
  },

  computed: {
    displayed() {
      if(this.$route && (this.$route.name === 'sets' || this.$route.name === 'set')) {
        return [];
      }

      const previous = keyBy(this.previous || [], 'id');
      const current = keyBy(this.sets || [], 'setDiscountId');

      return pickBy(current, (c, id) => !previous[id] || previous[id].quantity < c.quantity);
    }
  },

  methods: {
    getSetsFromLocalStorage() {
      try {
        const previous = LocalStorage.get(LocalStorageKeys.LAST_SEEN_SET_DISCOUNT);
        if(previous) {
          return JSON.parse(previous);
        }
      } catch(e) {
        console.warn('Failed to retrieve last seen set discounts from local storage.');
        console.warn(e);
      }
      return {};
    },

    saveSetsToLocalStorage(sets) {
      try {
        LocalStorage.set(LocalStorageKeys.LAST_SEEN_SET_DISCOUNT, JSON.stringify(sets));
      } catch(e) {
        console.warn('Failed to save last seen set discount to local storage');
        console.warn(e);
      }
    },

    mapSetsToQuantities(sets) {
      if(sets) {
        return sets.map(set => ({ id: set.setDiscountId, quantity: set.quantity }));
      }
      return null;
    }
  },

  watch: {
    sets: {
      immediate: true,
      handler(newSets, oldSets) {
        if(isEqual(this.mapSetsToQuantities(newSets), this.mapSetsToQuantities(oldSets))) {
          return;
        }

        if(oldSets) {
          this.previous = this.mapSetsToQuantities(oldSets);
        }

        if(newSets) {
          this.saveSetsToLocalStorage(this.mapSetsToQuantities(newSets));
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import '~@article/pixel/dist/style/variables';

.set-discount {
  background-color: var(--white);
  display: flex;
  align-items: start;
  margin-top: var(--space-4);
  padding: var(--space-4);

  @media (max-width: $mobile-breakpoint - 1) {
    margin-right: 0;
  }

  &.set-discount-grey {
    background-color: var(--grey-ultra-light);
  }

  p {
    display: inline-block;
    margin: 0;
    font-size: 14px;
    line-height: 1.5em;
  }

  img {
    display: inline-block;
    padding-right: var(--space-4);
    padding-top: var(--space-2);
    width: 30px;
  }
}
</style>
